import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL = (currentDomain === 'localhost' || currentDomain === '127.0.0.1' || currentDomain === 'aiconnect.com.tr'  || currentDomain === 'demo.aiconnect.com.tr' )
//   ? 'https://apis.aiconnect.com.tr/extension'
//   : `https://apis.${currentDomain}/extension`;

const ExtensionServices = {
  list: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
    });
    return axios.get(`${API_BASE_URL}/extension/list?${params.toString()}`);
  },
  addnewsip: (data) => {
    return axios.post(`${API_BASE_URL}/extension/addnewsip`, data);
  },
  addnewvir: (data) => {
    return axios.post(`${API_BASE_URL}/extension/addnewvir`, data);
  },
  insertsip: (data) => {
    return axios.post(`${API_BASE_URL}/extension/insertsip`, data);
  },
  insertvir: (data) => {
    return axios.post(`${API_BASE_URL}/extension/insertvir`, data);
  },
  editsip: (data) => {
    return axios.post(`${API_BASE_URL}/extension/editsip`, data);
  },
  editvir: (data) => {
    return axios.post(`${API_BASE_URL}/extension/editvir`, data);
  },
  updatevir: (data) => {
    return axios.post(`${API_BASE_URL}/extension/updatevir`, data);
  },
  updatesip: (data) => {
    return axios.post(`${API_BASE_URL}/extension/updatesip`, data);
  },
  delete: (data) => {
    return axios.post(`${API_BASE_URL}/extension/delete`, data);
  },
  zoiperQR: (data) => {
    return axios.post(`${API_BASE_URL}/extension/zoiperQR`, data);
  },
  waveQR: (data) => {
    return axios.post(`${API_BASE_URL}/extension/waveQR`, data);
  },
  qrPortSip: (data) => {
    return axios.post(`${API_BASE_URL}/extension/qrPortSip`, data);
  },
  downloadAll: (data) => {
    const params = new URLSearchParams({
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
    });
    return axios.get(
      `${API_BASE_URL}/extension/reportDownloadAll?${params.toString()}`
    );
  },
};

export default ExtensionServices;
